
const INITIAL_NATIONAL_TEAM_GROUP_STATE = {
  isError: false,
  error: {},
  errorTitle: '',
  errorMessage: ''
};  

const NTGroupData = {
  INITIAL_NATIONAL_TEAM_GROUP_STATE,
};

export default NTGroupData;